module.exports = __webpack_public_path__ + "static/media/close-icon-small.186e8556.svg";